// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo___O58X7"};